import VueGtag from "vue-gtag";

export default async ({ app, router }) => {
  app.use(
    VueGtag,
    {
      config: { id: "G-B22Z8Y0KWW" },
    },
    router
  );
};
